var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._v(" Ich habe die "),
    _c(
      "span",
      {
        staticClass: "text-decoration-underline pointer",
        on: { click: _vm.clickAgbs },
      },
      [_vm._v("AGBs")]
    ),
    _vm._v(" gelesen und akzeptiere diese "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }